import { gql } from '@apollo/client';

export const EXPORT_INTERVENTIONS = gql`
  query ExportInterventions($input: ExportArgs) {
    interventions: exportInterventions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          accredited
          accreditation
          description
          fromDate
          grades {
            id
            value
          }
          id
          impactThemes {
            id
            name
          }
          name
          outcomeThemes {
            id
            name
          }
          phase {
            id
            name
          }
          programme {
            id
            name
          }
          serviceProviders {
            id
            name
          }
          subjects {
            id
            subjectGradeReference
          }
          theoryOfChange
          toDate
          treatmentGroup {
            id
            name
          }
        }
      }
    }
  }
`;
